import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiMail, FiArrowRight, FiArrowLeft, FiAlertCircle, FiCheckCircle, FiLock, FiHome } from 'react-icons/fi';
import { authAPI } from '../../services/api';
import './auth.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successData, setSuccessData] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await authAPI.forgotPassword({ email });
      setSuccessData(res.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      {/* Panneau gauche */}
      <div className="auth-left">
        <div className="auth-left-content">
          <div className="auth-brand">
            <div className="auth-brand-icon">🏢</div>
            <div className="auth-brand-name">Gestion<span>Immo</span></div>
          </div>
          <h2>Récupérez l'accès à votre compte en toute sécurité</h2>
          <p>
            Entrez votre adresse email enregistrée. Nous vous enverrons un lien ainsi qu'un code de vérification à 6 chiffres pour réinitialiser votre mot de passe.
          </p>
          <div style={{ marginTop: 30, background: 'rgba(255,255,255,0.08)', borderRadius: 12, padding: '16px 20px', border: '1px solid rgba(255,255,255,0.12)' }}>
            <div style={{ fontWeight: 600, fontSize: 14, color: '#fff', display: 'flex', alignItems: 'center', gap: 8 }}>
              <FiLock style={{ color: '#a78bfa' }} /> Sécurité garantie
            </div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)', marginTop: 4, lineHeight: 1.5 }}>
              Le lien et le code générés sont à usage unique et expirent automatiquement après 60 minutes.
            </div>
          </div>
        </div>
      </div>

      {/* Panneau droit */}
      <div className="auth-right">
        <div className="auth-right-header">
          <h1>Mot de passe oublié 🔐</h1>
          <p>Réinitialisez votre mot de passe en quelques étapes simples</p>
        </div>

        {error && (
          <div className="auth-alert-error" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <FiAlertCircle size={16} />
            {error}
          </div>
        )}

        {successData ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#dcfce7', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px auto', color: '#16a34a' }}>
              <FiCheckCircle size={36} />
            </div>
            <h3 style={{ fontSize: 18, color: '#1e293b', marginBottom: 8 }}>Instructions envoyées !</h3>
            <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.6, marginBottom: 20 }}>
              {successData.message || `Un email a été envoyé à ${email} avec les instructions.`}
            </p>

            {successData.resetCode && (
              <div style={{ background: '#f5f3ff', border: '1px dashed #7c3aed', borderRadius: 8, padding: 14, marginBottom: 20 }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: '#7c3aed', textTransform: 'uppercase' }}>Code de test (mode dev)</span>
                <div style={{ fontSize: 26, fontWeight: 800, color: '#5b21b6', letterSpacing: 4, marginTop: 4 }}>
                  {successData.resetCode}
                </div>
              </div>
            )}

            <button
              className="auth-btn-primary"
              onClick={() => navigate(`/reset-password?email=${encodeURIComponent(email)}${successData.token ? `&token=${encodeURIComponent(successData.token)}` : ''}`)}
              style={{ marginBottom: 16 }}
            >
              Saisir le code / Nouveau mot de passe
              <FiArrowRight size={18} />
            </button>

            <div>
              <Link to="/login" style={{ color: '#7c3aed', textDecoration: 'none', fontSize: 14, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <FiArrowLeft size={16} /> Retour à la connexion
              </Link>
            </div>
          </div>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Adresse email associée à votre compte</label>
              <div className="auth-input-wrapper">
                <FiMail size={16} className="auth-input-icon" />
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="Ex: admin@gestion.ml"
                  required
                  autoFocus
                  autoComplete="email"
                />
              </div>
            </div>

            <button type="submit" className="auth-btn-primary" disabled={loading} style={{ marginTop: 10 }}>
              {loading ? (
                <>
                  <span style={{ width: 16, height: 16, border: '2px solid rgba(255,255,255,0.3)', borderTopColor: 'white', borderRadius: '50%', animation: 'spin 0.8s linear infinite', display: 'inline-block' }} />
                  Envoi des instructions...
                </>
              ) : (
                <>
                  Envoyer les instructions
                  <FiArrowRight size={18} />
                </>
              )}
            </button>

            <div style={{ textAlign: 'center', marginTop: 24 }}>
              <Link to="/login" style={{ color: '#64748b', textDecoration: 'none', fontSize: 13, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <FiArrowLeft size={14} /> Revenir à la page de connexion
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
